module.exports = __webpack_public_path__ + "static/img/beans.b0e46177.png";